import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import { X } from "lucide-react";
import { ALL_ICONS } from "../../assets/icons/AllIcons";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { RazorDateTime } from "../../components/razor-reuse";
import {
  deleteNotification,
  markAllNotification,
  markNotificationRead,
} from "../../redux/notification";

interface drawerProp {
  open: boolean;
  onClose: () => void;
}

export default function NotificationDrawer({ open, onClose }: drawerProp) {
  const { notification_data, loading } = useSelector(
    (state: RootState) => state.notification
  );
  const dispatch = useDispatch();

  return (
    <Drawer
      open={open}
      onClose={onClose}
      direction="right"
      className="bg-white"
      size="349px"
      overlayClassName="!backdrop-blur-md"
    >
      <div className="flex justify-between items-center px-[25px] py-[12px] bg-primary text-white">
        <p className="font-medium text-[14px]">Notification</p>
        <div className="inline-flex items-center gap-x-[16px]">
          {notification_data?.length > 0 && (
            <abbr
              title="Mark all as read"
              className="cursor-pointer [&_svg]:size-[20px]"
              onClick={() => {
                dispatch(markAllNotification({}) as any);
              }}
            >
              {ALL_ICONS.doubleCheck}
            </abbr>
          )}
          <span
            onClick={onClose}
            className="size-[24px] bg-[#FFEFEB] text-[#CC0905] rounded-full grid place-content-center cursor-pointer"
          >
            <X className="size-[14px]" />
          </span>
        </div>
      </div>
      {loading && <div className="custom-loader" />}

      {notification_data?.length < 1 ? (
        <section className="h-full grid place-content-center text-center px-[25px]">
          <div className="">
            <figure className="size-fit [&_svg]:size-[63px] mx-auto mb-[22px]">
              {ALL_ICONS.emptynotification}
            </figure>
            <p className="text-[#3E4345] text-[16px] mb-[4px]">
              You don’t have any notifications
            </p>
            <p className="text-[#758089] text-[12px] max-w-[200px] mx-auto">
              But as soon as something happens, you'll find it right here.
            </p>
          </div>
        </section>
      ) : (
        <section className="h-[calc(100vh-50px)] custom-scroll px-[23px] py-[21px] space-y-[21px]">
          {notification_data?.map((item) => (
            <div
              key={item?.id}
              className="border-[0.5px] border-[#3C477F1A] rounded-[8px] px-[16px] py-[11px] group hover:shadow-sm hover:border-[1px] *:transition-all *:ease-in-out *:duration-1000"
            >
              <div className="flex justify-between items-center mb-[11px]">
                <p className="text-[#596080] text-[14px]">{item?.title}</p>
                <div className="space-x-[16px] inline-flex items-center">
                  {!item?.is_read && (
                    <span
                      onClick={() => {
                        dispatch(markNotificationRead({ id: item?.id }) as any);
                      }}
                      className="text-[#758089] text-[10px] cursor-pointer relative inline-block before:contents-[''] before:absolute before:-bottom-1 before:left-0 before:h-[1.5px] before:w-0 before:bg-[#758089] before:transition-all before:duration-300 hover:before:w-full"
                    >
                      Mark as read
                    </span>
                  )}
                  <span
                    className={`block rounded-full size-[6px] ${
                      item?.is_read ? "bg-[#758089]" : "bg-[#E11900]"
                    }`}
                  />
                </div>
              </div>
              <div className="text-[#758089] text-[12px] font-light mb-[20px]">
                <p>{item?.body}</p>
                <span className="mt-[4px]">
                  {" "}
                  <RazorDateTime
                    hideAgo
                    hideTime={true}
                    date={item?.created_at}
                    className="[&_span]:!text-[#758089] mt-[2px]"
                  />
                </span>
              </div>
              <div
                className={`flex gap-x-[13px] -mt-[10px] group-hover:max-h-[50px] overflow-y-hidden max-h-0`}
              >
                {/* <button className="16px; px-[12px] py-[4px] rounded-[4px] border border-primary text-[12px] font-medium text-primary">
                  view
                </button> */}
                <button
                  onClick={() => {
                    dispatch(deleteNotification({ id: item?.id }) as any);
                  }}
                  className="[&_svg]:size-[22px]"
                >
                  {ALL_ICONS.trashIcon}
                </button>
              </div>
            </div>
          ))}
        </section>
      )}
    </Drawer>
  );
}
